import { Route, Routes } from "react-router-dom";
import Login from "./login/Login";
import Dashboard from "./dashboard/Dashboard";

export default function Admin() {
    return (
        <Routes>
            <Route path="/dashboard/*" element={ <Dashboard />} />

            <Route path="/" element={ <Login /> } />
            <Route path="*" element={ <Login /> } />
        </Routes>
    )
}